export default "__VITE_ASSET__U52aAdeJ__"